import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WebSocketService } from '../../../../services/web-socket.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { NewViewService } from '../../../../services/new-view.service';

/**
 * Navigation bar component
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent implements OnInit {
  /**
   * Current user
   */
  currentUser: string;

  /**
   * Trigger to pass filter object
   */
  @Output() toggleMenuEvent: EventEmitter<any> = new EventEmitter();

  /**
   * Is menu open
   */
  isMenuOpen: boolean;

  /**
   * Constructor
   *
   * @param authService AuthenticationService
   */
  constructor(private authService: AuthenticationService, public wsService: WebSocketService, public newView: NewViewService) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.currentUser = this.authService.currentUser.name;
  }

  /**
   * Logout
   */
  logout(): void {
    this.authService.logout();
  }

  /**
   * Toggle menu
   */
  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.toggleMenuEvent.emit({ toggleMenu: this.isMenuOpen });
  }
}
